import { Dimension } from '../../../../../features/dimension/types/Dimension'

export const isOwnSource = (source?: string): boolean => !source || source === 'FINADECK'

export const canRenameOrDelete = (dimension: Dimension, canEdit: boolean): boolean =>
  canEdit && isOwnSource(dimension.source)

export const tagLabel = (source?: string): string => (source || 'FINADECK').toUpperCase()
